// FAQ数据配置
export interface FaqItem {
  label: string;
  children: string | React.ReactElement;
}

// FAQ问题数据（用于faqJsonLd）
export interface FaqQuestion {
  question: string;
  answer: string;
}

// 获取FAQ数据列表（用于组件显示）
export const getFaqDataList = (t: (key: string) => string): FaqItem[] => [
  {
    label: t(`What is the Instagram Post Viewer?`),
    children: t(
      `The Instagram Post Viewer is a online tool that lets you browse public Instagram profiles anonymously—no login required. It allows you to view public Instagram profiles, posts, directly from your web browser without needing to log into an Instagram account. Just enter the username of any public profile and start exploring privately and securely.`
    ),
  },
  {
    label: t(`Do I need an Instagram account to use the Post Viewer?`),
    children: t(`No, you don't need an Instagram account to use the Post Viewer.`),
  },
  {
    label: t(`Can I view private Instagram profiles with the Post Viewer?`),
    children: t(
      `No, the Post Viewer only allows access to public Instagram profiles and content. Private profiles cannot be viewed without permission.`
    ),
  },
  {
    label: t(`Is the Post Viewer safe and anonymous?`),
    children: t(
      `Yes, Dolphin Radar's Post Viewer is safe and anonymous. No login or personal data is required, ensuring private browsing. We do not host any Instagram content. Only publicly available content is accessible. All rights belong to their respective owners.`
    ),
  },
  {
    label: t(`How can I anonymously view someone's Instagram Stories?`),
    children: t(
      `To anonymously view someone's Instagram Stories, you can use DolphinRadar's Anonymous Story Viewer. This tool allows you to watch any public Instagram Stories without the user knowing, ensuring your privacy.`
    ),
  },
  {
    label: t(`How can I see who someone liked or followed on Instagram?`),
    children: t(
      `If you want to track who someone has liked or followed on Instagram, DolphinRadar's Instagram Activity Tracker is the perfect solution. It provides detailed reports on their Instagram activity, including likes, new follows, and more.`
    ),
  },
  {
    label: t(`Does this support Threads content?`),
    children: t(
      `Not directly. But we've already launched a tool that lets you download Threads videos, images, and GIFs in one click — try our Threads Downloader.`
    ),
  },
];

// 获取FAQ问题数据（用于page3FaqJsonLd）
export const getFaqQuestions = (t: (key: string) => string): FaqQuestion[] => {
  const faqData = getFaqDataList(t);
  return faqData.map((item) => ({
    question: item.label,
    answer: item.children as string,
  }));
};
